//------------------------------------------------
//
//	ReU: 拡大モーダルを開く画像のカーソル追従
//	クリックで拡大モーダルが開く画像の上で、マウスの位置に「＋」の丸を出す。
//	丸の見た目は CSS（.zoomCursor）が描く＝ここは表示/位置だけを持つ。
//	動くのは「マウスで操作している広い画面」だけ。条件を満たしたときだけ
//	<html> に .zoomCursorOn が付き、CSS 側の「元のカーソルを消す」指定もそれに連動する。
//	＝この JS が動かない環境では従来どおり虫めがねカーソル＋隅の拡大アイコンに落ちる。
//
//------------------------------------------------
(() => {
    // 対象＝画像に重ねてある透明ボタン（.zoomWrap 共通）と、商品ギャラリーのメイン画像
    const OPENER_SELECTOR = '.zoomWrap modal-opener button, .product__modal-opener--image .product__media-toggle';
    // マウスで操作している広い画面だけ。タッチ端末とタブレット帯は対象外
    const ENABLE_QUERY = '(min-width: 1025px) and (hover: hover) and (pointer: fine)';

    const mql = window.matchMedia(ENABLE_QUERY);

    let cursor = null;
    let pending = null;

    //------------------------------------------------
    //	丸の出し入れと追従
    //------------------------------------------------
    const getCursor = () => {
        if (!cursor) {
            // span で作る。中身が空なので div だと base.css の div:empty{display:none} に当たって消える
            cursor = document.createElement('span');
            cursor.className = 'zoomCursor';
            cursor.setAttribute('aria-hidden', 'true');
            document.body.appendChild(cursor);
        }
        return cursor;
    };

    const place = (x, y) => {
        getCursor().style.translate = `${x}px ${y}px`;
    };

    // 追従はフレームに1回で足りる（マウスは1フレームに何度も動く）
    const move = (x, y) => {
        if (pending) return;
        pending = requestAnimationFrame(() => {
            pending = null;
            place(x, y);
        });
    };

    const show = () => getCursor().classList.add('isShown');

    const hide = () => {
        if (cursor) cursor.classList.remove('isShown');
    };

    //------------------------------------------------
    //	イベント（document 委譲）
    //	モーダルの中身や商品情報は後から差し替わるので、要素ごとには付けない
    //------------------------------------------------
    const onOver = (event) => {
        const opener = event.target.closest(OPENER_SELECTOR);
        if (!opener) return;
        // 出る位置は待たずに置く（フレームを待つと、前に居た場所から滑り込んで見える）
        place(event.clientX, event.clientY);
        show();
    };

    const onOut = (event) => {
        if (!event.target.closest(OPENER_SELECTOR)) return;
        // 対象の内側での行き来（子要素へ移った）では消さない
        if (event.relatedTarget && event.relatedTarget.closest(OPENER_SELECTOR)) return;
        hide();
    };

    const onMove = (event) => {
        if (!cursor || !cursor.classList.contains('isShown')) return;
        move(event.clientX, event.clientY);
    };

    // モーダルが開いたら丸は用済み（開いた瞬間はマウスが動かないので mouseout を待てない）
    const onClick = (event) => {
        if (event.target.closest(OPENER_SELECTOR)) hide();
    };

    //------------------------------------------------
    //	有効/無効の切替（画面幅や入力機器が変わったときも追従）
    //------------------------------------------------
    const listeners = [
        ['mouseover', onOver],
        ['mouseout', onOut],
        ['mousemove', onMove],
        ['click', onClick],
    ];

    const enable = () => {
        document.documentElement.classList.add('zoomCursorOn');
        listeners.forEach(([type, fn]) => document.addEventListener(type, fn, { passive: true }));
    };

    const disable = () => {
        document.documentElement.classList.remove('zoomCursorOn');
        listeners.forEach(([type, fn]) => document.removeEventListener(type, fn));
        hide();
    };

    const apply = () => (mql.matches ? enable() : disable());

    apply();
    // change だけに頼らない＝画面幅の変化を拾い損ねる環境があるため、resize でも判定し直す。
    // enable/disable は何度呼んでも同じ結果になるので重ねて呼んで構わない
    mql.addEventListener('change', apply);
    window.addEventListener('resize', apply, { passive: true });
})();
